export default __webpack_public_path__ + "static/media/zero-grau-mais-us.af990809.png";